import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import '../../styles/AdminPage.css';

const API = process.env.REACT_APP_BACKEND_URL;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await axios.post(`${API}/api/admin/forgot-password`, { email });
      setDone(true);
    } catch (err) {
      // Even on error we show the same generic message — never leak whether the email exists.
      // We still log server-side errors for ops visibility.
      setDone(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-page admin-login-page">
      <div className="admin-login-card">
        <h1 className="admin-login-title">Reset password</h1>
        <p className="admin-login-subtitle">
          Enter your admin email. If an account exists, we'll send a one-time reset link
          (valid for 30 minutes).
        </p>

        {!done ? (
          <form onSubmit={submit} className="admin-login-form">
            <label className="admin-field">
              <span className="admin-field-label">Admin email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
                className="admin-input"
                data-testid="admin-forgot-email"
              />
            </label>
            {error && <p className="admin-login-error">{error}</p>}
            <button
              type="submit"
              className="admin-login-btn"
              disabled={busy}
              data-testid="admin-forgot-submit"
            >
              {busy ? <Loader2 className="admin-spinner-inline" size={16} /> : 'Send reset link'}
            </button>
          </form>
        ) : (
          <div className="admin-forgot-done" data-testid="admin-forgot-success">
            <p>
              ✅ If an account exists for <strong>{email}</strong>, a reset link has been sent.
              Check your inbox (and spam folder) within the next minute.
            </p>
            <p className="admin-login-footer">
              The link expires in 30 minutes and can only be used once.
            </p>
          </div>
        )}

        <p className="admin-login-forgot">
          <Link to="/admin">← Back to login</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
